/*
 * Skeleton loaders — three primitives covering the loading shapes we
 * actually use: a row in a table, a stat card, and a free-form block.
 * CSS-only animation in styles.css (.skeleton class).
 */

export function SkeletonText({ width = "100%" }: { width?: string }) {
  return <span className="skeleton skeleton-text" style={{ width }} aria-hidden />;
}

export function SkeletonStat() {
  return (
    <div className="stat" aria-busy>
      <div className="stat-label"><SkeletonText width="60%" /></div>
      <div className="stat-value"><SkeletonText width="40%" /></div>
      <div className="stat-hint"><SkeletonText width="50%" /></div>
    </div>
  );
}

export function SkeletonTable({ rows = 5, columns = 5 }: { rows?: number; columns?: number }) {
  return (
    <table className="transfer-table" aria-busy>
      <thead>
        <tr>
          {Array.from({ length: columns }).map((_, i) => (
            <th key={i}><SkeletonText width="60%" /></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, r) => (
          <tr key={r}>
            {Array.from({ length: columns }).map((_, c) => (
              <td key={c}><SkeletonText width={c === 0 ? "85%" : "60%"} /></td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
